import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Resources from '../resourceLinks/ResourceLinks';
import TextArea from './ShortResponseTextArea';
import Question from './ShortResponseQuestion';
import Feedback from './ShortResponseFeedback';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as xAPIHelper from '../../../helpers/xAPIHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as componentConstants from '../../../constants/componentConstants';
import {SHORT_ANSWER_REVIEW_CONFIG} from '../../../models/dialogModels';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';


class ShortResponse extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            shortResponseQuestions: this.props.shortResponseQuestions,
            questionsRespondedTo: [],
            kpis: [],
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            renderQuestions: false,
            renderedQuestions: [],
            displayInline: (this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_INLINE || (this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_ELSEWHERE_IF_SCORM && this.props.contentData.experience.tracking_type !== appConstants.TRACKING_TYPE_SCORM)) && this.props.contentData.experience.tracking_type !== appConstants.TRACKING_TYPE_SCORM,
            submitted: false,
            showFeedback: false,
            feedbackViewed: false,
            selfRate: this.props.screenObject.assess_type !== objectConstants.ASSESSED_TYPE_NONE,
            saveRating: this.props.screenObject.assess_type === objectConstants.ASSESSED_TYPE_SCORED && appHelper.isDefined(appHelper.getBite(this.props.callbacks.getBiteId()).score_kpi),
            callbacks: {},
            showProgressionButton: false,
            assetData: {},
            screenStatus: "",
            checkComplete: false,
            resourceLinks: [],
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            hasResources: false,
            resourcesAreComplete: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            score_kpi: appHelper.getBite(this.props.callbacks.getBiteId()).score_kpi,
            userDataKpi: {},
            kpi_user_rating: {
                kpi_id: appHelper.isDefined(appHelper.getBite(this.props.callbacks.getBiteId()).score_kpi) ? appHelper.getBite(this.props.callbacks.getBiteId()).score_kpi.kpi_id : null,
                value: null
            },
            checkPostXAPIResponse: false,
            checkGetXAPIResponse: false,
            currentAttempt: 1,
            navigate: false,
            submit_label: appHelper.getLocaleString("submit_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            complete_activity_label: appHelper.getLocaleString("complete_activity_label"),
        };
        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.onRendered = this.onRendered.bind(this);
        this.setRenderedQuestions = this.setRenderedQuestions.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.updateField = this.updateField.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.editResponses = this.editResponses.bind(this);
        this.onContinue = this.onContinue.bind(this);
        this.scrollToFeedback = this.scrollToFeedback.bind(this);
        this.setStatusClass = this.setStatusClass.bind(this);
        this.onFeedbackComplete = this.onFeedbackComplete.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.storeUserShortResponses = this.storeUserResponse.bind(this);
        this.onPanelClick = this.onPanelClick.bind(this);
        this.onReviewObject = this.onReviewObject.bind(this);
        this.postXAPIResponse = this.postXAPIResponse.bind(this);
        this.getXAPIResponse = this.getXAPIResponse.bind(this);
        this.updateUserRating = this.updateUserRating.bind(this);
        this.onPanelClickByKeyboardAccessibility = this.onPanelClickByKeyboardAccessibility.bind(this);
        this.editResponsesOnKeyboardAccessibility = this.editResponsesOnKeyboardAccessibility.bind(this);
        this.setKeyboardAcessibility = this.setKeyboardAcessibility.bind(this);
        this.getPreviousResponse = this.getPreviousResponse.bind(this);
        this.getNextResponse = this.getNextResponse.bind(this);
        this.updateSumbission = this.updateSumbission.bind(this);
        this.handleNoFeedback = this.handleNoFeedback.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
    }

    componentDidMount() {
        this.setCallbacks();

        this.setRenderedQuestions();
        this.setResources();
        this.getScreenStatus();
        this.show();

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if (this.state.shortResponseQuestions !== nextProps.shortResponseQuestions) {
            this.setState({shortResponseQuestions: Object.assign([], nextProps.shortResponseQuestions)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                submit_label: appHelper.getLocaleString("submit_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                complete_activity_label: appHelper.getLocaleString("complete_activity_label"),
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkComplete) {

            this.onComplete();
        }
        if (this.state.checkPostXAPIResponse) {
            this.postXAPIResponse();
        }

        if (this.state.checkGetXAPIResponse) {
            this.getXAPIResponse();
        }
    }

    postXAPIResponse() {
        this.setState({checkPostXAPIResponse: false});
        let voidCompleteRecords = true;
        let parentScreen = this.props.callbacks.getSubScreenParent();
        let params = {
            renderedQuestions: this.state.renderedQuestions,
            userData: this.state.userData,
            bite_id: this.props.callbacks.getBiteId(),
            screen_id: this.props.callbacks.getScreenId(),
            parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
            asset_id: this.state.screenObject.asset_id,
            currentAttempt: 1,
            kpi_user_rating: this.state.kpi_user_rating
        };
        let interactionDataArray = xAPIHelper.setShortResponseInteractions(this.state.screenObject, params);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            for (let i = 0; i < interactionDataArray.length; i++) {
                let interactionData = interactionDataArray[i];
                let screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
                let category = {
                    constant: componentConstants.SHORT_RESPONSE,
                    label: componentConstants.SHORT_RESPONSE_LABEL
                };
                this.props.actions.postActvityStatement(screen, interactionData, category, voidCompleteRecords);
            }
        }

    }

    getXAPIResponse() {
        this.setState({checkGetXAPIResponse: false});
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let renderedQuestions = Object.assign([], this.state.renderedQuestions);
            let returnedResponses = 0;
            let parentScreen = this.props.callbacks.getSubScreenParent();
            let params = {
                renderedQuestions: this.state.renderedQuestions,
                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
                asset_id: this.state.screenObject.asset_id,
            };

            let interactionDataArray = xAPIHelper.getShortResponseIds(this.state.screenObject, params);

            for (let i = 0; i < interactionDataArray.length; i++) {
                let interactionData = interactionDataArray[i];
                this.props.actions.getActvityStatement(interactionData).then((responseObj) => {
                    if (appHelper.isDefined(responseObj.statement)) {
                        let response = responseObj.statement.result.response;
                        let responseQuestion = appHelper.getArrayObjectByKey(renderedQuestions, "id", responseObj.id);
                        let responseQuestionIndex = appHelper.getArrayObjectIndexByKey(renderedQuestions, "id", responseObj.id);
                        responseQuestion = Object.assign({}, responseQuestion, {
                            response: response,
                        });

                        renderedQuestions = dataHelper.immutableSplice(renderedQuestions, responseQuestionIndex, 1, responseQuestion);
                        returnedResponses++;
                        if (returnedResponses === renderedQuestions.length) {
                            this.setState({
                                renderedQuestions: Object.assign([], renderedQuestions),
                                renderQuestions: true
                            });
                        }
                    } else {
                        this.setState({renderQuestions: true});
                    }

                }).catch(error => {
                });
            }
        }

    }

    updateUserRating(kpi_user_rating) {
        this.setState({kpi_user_rating: Object.assign({}, kpi_user_rating)});
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.callbacks, {
                updateField: this.updateField,
                updateUserRating: this.updateUserRating
            })
        });
    }


    updateField(data) {
        let question = appHelper.getArrayObjectByKey(this.state.renderedQuestions, "id", data.id);
        let questionIndex = appHelper.getArrayObjectIndexByKey(this.state.renderedQuestions, "id", data.id);
        question = Object.assign({}, question, {
            response: data.response
        });
        let updatedQuestions = dataHelper.immutableSplice(this.state.renderedQuestions, questionIndex, 1, question);
        this.setState({renderedQuestions: Object.assign([], updatedQuestions)});
    }

    setRenderedQuestions() {
        let renderedQuestions = [];
        let allQuestions = Object.assign([], this.state.shortResponseQuestions);
        _.forEach(this.state.screenObject.questions, function (question) {
            let questionData = appHelper.getArrayObjectByKey(allQuestions, "id", question.id);


            if (appHelper.isDefined(questionData.id)) {
                renderedQuestions = dataHelper.immutablePush(renderedQuestions, questionData);
            }
        });

        this.setState({
            renderQuestions: localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2,
            renderedQuestions: Object.assign([], renderedQuestions),
            checkGetXAPIResponse: true,
        });
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status,
            submitted: screenStatus === objectConstants.STATUS_COMPLETE,
            feedbackViewed: screenStatus === objectConstants.STATUS_COMPLETE
        });
    }

    getObjectStatus() {
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {

            this.onComplete();

        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else if (this.state.isResourceObject) {
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({
                    status: objectConstants.STATUS_COMPLETE,
                    submitted: true,
                    checkComplete: true,
                    feedbackViewed: true
                });
            }

        }

    }


    show() {
        this.scrollToTop();
        let optionRef = this.refs[`${this.state.screenObject.asset_id}_question`];
        TweenLite.set(optionRef, {height: "auto"});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.getObjectStatus);
    }

    onRendered() {
        if (this.state.isResourceObject) {
            this.props.callbacks.onObjectRendered();
        }
        this.getObjectStatus();
    }

    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
    }

    scrollToTop() {
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[`${this.state.screenObject.asset_id}_question`];
            let scrollTo = this.props.callbacks.scrollTo;

            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if (this.state.resourcesAreComplete) {
            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
                if (this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_NO_FEEDBACK && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE) {
                     //this.handleProgression();
                        this.enableProgression();

                } else {
                    if (!hasNextObject && !this.state.isResourceObject) {
                        //console.log('progression 1')
                        this.handleProgression();
                    } else if (!hasNextObject && this.state.isResourceObject) {
                        this.handleProgression();
                    } else if (this.state.isResourceObject) {
                        this.handleProgression();
                    } else {
                        //this.enableProgression();
                        this.handleProgression();
                    }
                }

            } else {
                if (this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_NO_FEEDBACK) {
                    if((appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE )|| (!hasNextObject && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE)) {
                        //this.handleProgression();
                        if(this.state.displayInline) {
                            this.enableProgression();
                        }else{
                            this.handleProgression();
                        }
                    }else{
                        this.handleNoFeedback();
                    }
                    //this.handleProgression();
                } else {
                    this.handleProgression();
                }
            }
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
           // console.log('i am getting here',this.props.callbacks.getScreenStatus());
            this.setState({showProgressionButton: true});
        }
    }

    handleNoFeedback(){
        this.setState({status: objectConstants.STATUS_COMPLETE});
        //this.handleProgression();
        let handleProgression = this.handleProgression;
        let navigateToNextScreen = this.props.callbacks.navigateToNextScreen;
        setTimeout(function(){
            handleProgression();
           // navigateToNextScreen();
        },500);

    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = this.state.screenObject.progression;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: !this.props.callbacks.hasNextObject(this.props.index) && this.props.callbacks.getScreenStatus() === objectConstants.STATUS_COMPLETE && this.state.screenObject.progress !== objectConstants.OBJECT_PROGRESSION_CONTINUE,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE && !this.state.navigate,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);


        if(!this.props.callbacks.hasNextObject(this.props.index) && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE){
            //this.props.callbacks.navigateToNextScreen();
            let navigateToNextScreen = this.props.callbacks.navigateToNextScreen;
            setTimeout(function(){
                navigateToNextScreen();
            },1000);
        }
        /*if(appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_AUTO){
             let navigateToNextScreen = this.props.callbacks.navigateToNextScreen;


                navigateToNextScreen();
            },1000);
        }*/
    }

    onProgressionBtnClicked(event) {
        if (appHelper.isDefined(event)) {
            event.stopPropagation();
        }

        this.setState({showProgressionButton: false,navigate: true});
        if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
            this.handleProgression();
        } else {

            this.handleProgression();
            //this.props.callbacks.navigateToNextScreen();

            let navigateToNextScreen = this.props.callbacks.navigateToNextScreen;
            setTimeout(function(){
                navigateToNextScreen();
            },500);
        }
    }





    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }


    onSubmit(event) {
        if (appHelper.isDefined(event)) {
            event.stopPropagation();
        }
        let userDataKpi = {};
        if (appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id)) {
            let userBite = appHelper.getArrayObjectByKey(this.state.userData.bites, "bite_id", this.props.callbacks.getBiteId());
            let userDataKpis = appHelper.getArrayObjectByKey(userBite.kpis, "kpi_id", this.state.score_kpi.kpi_id);
            if (appHelper.isDefined(userDataKpis)) {
                userDataKpi = appHelper.getArrayObjectByKey(userDataKpis.history, "asset_id", this.state.screenObject.asset_id);
            }
        }

        let params = {
            userData: this.state.userData,
            bite_id: this.props.callbacks.getBiteId(),
            screen_id: this.props.callbacks.getScreenId(),
            parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
            asset_id: this.state.screenObject.asset_id,
            kpis: appHelper.isDefined(userDataKpi) && this.state.saveRating ? [
                {
                    kpi_id: appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id) ? this.state.score_kpi.kpi_id : null,
                    value: appHelper.isDefined(userDataKpi) && appHelper.isDefined(userDataKpi.statusIndicatorClass) && !isNaN(userDataKpi.statusIndicatorClass.value) ? userDataKpi.statusIndicatorClass.value : null
                }
            ] : []
        };


        if (localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.updateSumbission();

            this.props.actions.storeUserResponse(params).then((userData) => {


                this.props.actions.setSuspendData(userData).then((suspendData) => {
                    let params_2 = {
                        userData: userData,
                        answeredQuestions: this.state.renderedQuestions
                    };

                    this.props.actions.storeUserShortResponses(params_2).then((userData) => {

                        this.props.actions.setSuspendData(userData).then((suspendData) => {
                            //this.updateSumbission();


                        }).catch(error => {
                        });
                    }).catch(error => {
                    });
                }).catch(error => {
                });
            }).catch(error => {
            });
        } else {
            let showFeedback = this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE;


            this.setState({
                submitted: true,
                showFeedback: showFeedback && !this.state.feedbackViewed,
                checkPostXAPIResponse:  !showFeedback || this.state.status === objectConstants.STATUS_COMPLETE,
                checkComplete: !showFeedback && this.state.status !== objectConstants.STATUS_COMPLETE,
                status: !showFeedback || this.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : objectConstants.STATUS_IN_PROGRESS
            });
        }
    }

    updateSumbission() {
        let showFeedback = this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE;

        this.setState({
            submitted: true,
            showFeedback: showFeedback && !this.state.feedbackViewed,
            checkPostXAPIResponse: !showFeedback,
            checkComplete: !showFeedback && this.state.status !== objectConstants.STATUS_COMPLETE,
            status: !showFeedback || this.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : objectConstants.STATUS_IN_PROGRESS
        });
    }

    storeUserResponse() {
        let params = {
            userData: this.state.userData,
            bite_id: this.props.callbacks.getBiteId(),
            screen_id: this.props.callbacks.getScreenId(),
            parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
            asset_id: this.state.screenObject.asset_id,
            kpis: []
        };

        this.props.actions.storeUserResponse(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((suspendData) => {
                this.storeUserShortResponses();
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    storeUserShortResponses() {
        let params = {
            userData: this.state.userData,
            answeredQuestions: this.state.renderedQuestions
        };

        this.props.actions.storeUserShortResponses(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((suspendData) => {

                let showFeedback = this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE;
                this.setState({
                    submitted: true,
                    showFeedback: showFeedback,
                    checkComplete: !showFeedback,
                    status: !showFeedback || this.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : objectConstants.STATUS_IN_PROGRESS
                });
            }).catch(error => {
            });
        }).catch(error => {
        });
    }


    editResponses(event) {
        if (appHelper.isDefined(event)) {
            event.stopPropagation();
        }
        this.setState({submitted: false, currentAttempt: this.state.currentAttempt + 1});
    }

    onContinue(event) {
        if (appHelper.isDefined(event)) {
            event.stopPropagation();
        }
        this.setState({status: objectConstants.STATUS_COMPLETE, showFeedback: false});
        this.onProgressionBtnClicked(event);
    }

    scrollToFeedback(feedbackPos) {
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        this.props.callbacks.scrollTo(question.offsetTop + feedbackPos);
    }

    setStatusClass() {
        return this.state.status === objectConstants.STATUS_COMPLETE ? "complete" : "";
    }

    onFeedbackComplete() {
        this.setState({
            status: objectConstants.STATUS_COMPLETE,
            showFeedback: false,
            feedbackViewed: true,
            checkPostXAPIResponse: true,
            checkComplete: true,
        });

    }


    onPanelClick() {
        if (this.state.status === objectConstants.STATUS_COMPLETE && this.state.submitted) {
            this.onReviewObject();
        }
    }

    onReviewObject() {
        let userDataKpi = {};
        if (appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id)) {
            let userBite = appHelper.getArrayObjectByKey(this.state.userData.bites, "bite_id", this.props.callbacks.getBiteId());
            let userDataKpis = appHelper.getArrayObjectByKey(userBite.kpis, "kpi_id", this.state.score_kpi.kpi_id);
            if (appHelper.isDefined(userDataKpis)) {
                userDataKpi = appHelper.getArrayObjectByKey(userDataKpis.history, "asset_id", this.state.screenObject.asset_id);
            }
        }

        let config = Object.assign({}, SHORT_ANSWER_REVIEW_CONFIG,
            {
                title: this.state.locale.label,
                sourceId: `object_${this.state.screenObject.asset_id}`
            }
        );
        //locale.title

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child.componentProps = Object.assign({}, {
                screenObject: this.state.screenObject,
                responseData: {
                    bite_id: this.props.callbacks.getBiteId(),
                    screen_id: this.props.callbacks.getScreenId(),
                    object_id: this.state.screenObject.asset_id,
                    asset_id: this.state.screenObject.asset_id,
                    currentAttempt: 1,
                    currentStatus: objectConstants.STATUS_COMPLETE,
                    displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                    kpis: [
                        {
                            kpi_id: appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id) ? this.state.score_kpi.kpi_id : null,
                            value: appHelper.isDefined(userDataKpi) && appHelper.isDefined(userDataKpi.statusIndicatorClass) && !isNaN(userDataKpi.statusIndicatorClass.value) ? userDataKpi.statusIndicatorClass.value : null
                        }
                    ]
                },
                callbacks: this.props.callbacks
            });
        }
        this.props.actions.setNewDialog(config);
    }

    onPanelClickByKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            //event.preventDefault();
            event.stopPropagation();
            this.onPanelClick();
        }
    }

    editResponsesOnKeyboardAccessibility(event) {


        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            //event.preventDefault();
            event.stopPropagation();
            this.setState({submitted: false, currentAttempt: this.state.currentAttempt + 1});
            let focusEl = document.getElementById(`object_${this.state.screenObject.asset_id}`);
            if (appHelper.isDefined(focusEl)) {
                focusEl.focus();
            }
        }
    }

    setKeyboardAcessibility(event) {

        let idArray = event.target.id.split(`short_response_`);
        let id = parseInt(idArray[1]);
        if (appHelper.isDefined(event)) {
            if (event.which === keyboardConstants.ARROW_UP_KEY) {
                event.preventDefault();
                this.getPreviousResponse(id);
            }
            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
                event.preventDefault();
                this.getNextResponse(id);
            }
            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
                event.preventDefault();
                this.getPreviousResponse(id);
            }
            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
                event.preventDefault();
                this.getNextResponse(id);
            }
        }

    }

    getPreviousResponse(targetId) {
        let responseIndex = appHelper.getArrayObjectIndexByKey(this.state.renderedQuestions, "id", targetId);
        let nextResponse = this.state.renderedQuestions[responseIndex - 1];
        if (responseIndex <= 0) {
            nextResponse = this.state.renderedQuestions[this.state.renderedQuestions.length - 1];
        }

        let focusEl = document.getElementById(`short_response_${nextResponse.id}`);
        focusEl.focus();

    }

    getNextResponse(targetId) {
        let responseIndex = appHelper.getArrayObjectIndexByKey(this.state.renderedQuestions, "id", targetId);
        let nextResponse = this.state.renderedQuestions[responseIndex + 1];
        if (responseIndex === (this.state.renderedQuestions.length - 1)) {
            nextResponse = this.state.renderedQuestions[0];
        }
        let focusEl = document.getElementById(`short_response_${nextResponse.id}`);
        focusEl.focus();
    }


    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    render() {
        return (
            <div className={`learner-action`} ref={`${this.state.screenObject.asset_id}_question`}>
                {
                    appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                        ?
                        <div className={`content-character-expression`}>
                            <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                        </div>
                        :
                        null
                }
                <div className={`question-wrapper short-response   ${this.setStatusClass()}`}
                     onClick={this.onPanelClick} onKeyDown={this.onPanelClickByKeyboardAccessibility} tabIndex={0}
                     role="link">
                    <div className="object-container">
                        {
                            this.state.screenObject.show_title
                                ? <h4 dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                : null
                        }

                        {
                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 && this.state.locale.description !== "<p><br></p>"
                                ?
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                :
                                null
                        }

                        {
                            this.state.hasResources
                                ?
                                <div>
                                    <br/>
                                    <Resources resources={this.state.resourceLinks}
                                               onResourcesComplete={this.onResourcesComplete}/>
                                </div>
                                :
                                null
                        }
                        <br/>
                        {
                            this.state.renderQuestions
                                ?
                                this.state.renderedQuestions.map(question =>
                                    <div key={question.id} id={`short_response_${question.id}`} role="link"
                                         tabIndex="0" onKeyDown={this.setKeyboardAcessibility}>
                                        {this.state.displayInline
                                            ?
                                            <TextArea parentObject={this.state.screenObject}
                                                      screenObject={question}
                                                      callbacks={this.state.callbacks}
                                                      submitted={this.state.submitted}
                                            />
                                            :
                                            <Question parentObject={this.state.screenObject}
                                                      screenObject={question}
                                                      callbacks={this.state.callbacks}/>
                                        }
                                    </div>
                                )
                                :
                                <div className="pl-circle content">
                                    <div className="pl-circle1 pl-child"/>
                                    <div className="pl-circle2 pl-child"/>
                                    <div className="pl-circle3 pl-child"/>
                                    <div className="pl-circle4 pl-child"/>
                                    <div className="pl-circle5 pl-child"/>
                                    <div className="pl-circle6 pl-child"/>
                                    <div className="pl-circle7 pl-child"/>
                                    <div className="pl-circle8 pl-child"/>
                                    <div className="pl-circle9 pl-child"/>
                                    <div className="pl-circle10 pl-child"/>
                                    <div className="pl-circle11 pl-child"/>
                                    <div className="pl-circle12 pl-child"/>
                                </div>
                        }

                        {
                            !this.state.submitted && this.state.displayInline
                                ? <Button label={this.state.submit_label}
                                          id={`${this.state.screenObject.asset_id}_button`}
                                          onClick={this.onSubmit}/>

                                : null
                        }


                        {this.state.showProgressionButton && this.state.displayInline
                            ? <Button label={this.state.continue_label}
                                      id={`${this.state.screenObject}_button`}
                                      onClick={this.onProgressionBtnClicked}/>
                            : null
                        }
                        {
                            this.state.status === objectConstants.STATUS_COMPLETE && this.state.displayInline && this.state.submitted
                                ? <div className={`guroo-active-link text-center`} onClick={this.editResponses}
                                       onKeyDown={this.editResponsesOnKeyboardAccessibility} tabIndex={0} role="link">
                                    Edit Responses</div>
                                : null
                        }

                        {!this.state.displayInline
                            ?
                            <div className="content-panel text-center">
                                <div
                                    dangerouslySetInnerHTML={{__html: this.state.locale.response_elsewhere_instructions}}/>
                                {this.state.status !== objectConstants.STATUS_COMPLETE
                                    ?
                                    <Button label={this.state.complete_activity_label}
                                            id={`${this.state.screenObject}_button`}
                                            onClick={this.onContinue}/>
                                    : null
                                }
                            </div>
                            : null
                        }
                    </div>

                    {
                        this.state.showFeedback && !this.state.feedbackViewed
                            ?
                            <Feedback screenObject={this.state.screenObject} callbacks={this.state.callbacks}
                                      scrollToFeedback={this.scrollToFeedback} onComplete={this.onFeedbackComplete}
                                      selfRate={this.state.selfRate} saveRating={this.state.saveRating}/>
                            : null
                    }

                </div>
            </div>
        );
    }
}

ShortResponse.propTypes = {
    screenObject: PropTypes.object.isRequired,
    index: PropTypes.number,
    callbacks: PropTypes.object,
    shortResponseQuestions: PropTypes.array.isRequired,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ShortResponse.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        shortResponseQuestions: state.userData.short_response_questions,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShortResponse);



/** WEBPACK FOOTER **
 ** ./src/components/objects/shortResponse/ShortResponse.js
 **/